const trimTrailingSlash = (value) => value.replace(/\/+$/, '')

export const appConfig = Object.freeze({
  env: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
  appName: import.meta.env.VITE_APP_NAME || '万博体育',
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_BASE_URL || '/api'),
  siteCode: import.meta.env.VITE_SITE_CODE || '',
  publicPath: import.meta.env.BASE_URL,
  mockEnabled: import.meta.env.VITE_ENABLE_MOCK === 'true',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
})

export const resolveApiUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${appConfig.apiBaseUrl}${normalizedPath}`
}
